<div class="form-card" [class.form-error]="error">
  <ng-content></ng-content>
</div>
